<template>
  <input type="text" 
    autocomplete="off"
    :value="value"
    @input="$emit('input', $event.target.value)"
    @keydown="onKeydown($event)"/>
</template>

<script>
export default {
  name: "InputNumber",
  props: {
    value: {
      type: String,
      default: ""
    },
    integer: {
      type: Boolean,
      default: false
    },
    separator: {
      type: String,
      default: ","
    },
    decimalPlaces: {
      type: Number,
      default: 2
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    }
  },
  methods: {
    validate() {
      return true;
    },
    onKeydown(e) {
      // Allow only one dot/comma key for decimals:
      if (
        (this.separator === "." && (e.keyCode === 110 || e.keyCode === 190)) ||
        (this.separator === "," && e.keyCode === 188)
      ) {
        if (this.integer || (this.value || "").indexOf(this.separator) > -1) {
          e.preventDefault();
          return;
        }
      }

      // backspace, delete, tab, escape, enter
      let keys = [46, 8, 9, 27, 13];

      //dot
      if (this.separator === ".") {
        keys.push(110);
        keys.push(190);
      }

      //comma
      if (this.separator === ",") {
        keys.push(188);
      }

      // Allow these keys only:
      if (
        keys.indexOf(e.keyCode) >= 0 ||
        // Ctrl/cmd+A
        (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
        // Ctrl/cmd+C
        (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
        // Ctrl/cmd+R
        (e.keyCode === 82 && (e.ctrlKey || e.metaKey)) ||
        // Ctrl/cmd+X
        (e.keyCode === 88 && (e.ctrlKey || e.metaKey)) ||
        // home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39)
      ) {
        return;
      }

      if (
        (e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) &&
        (e.keyCode < 96 || e.keyCode > 105)
      ) {
        e.preventDefault();
      }
    }
  }
};
</script>
